import { render } from "./ba.vue?vue&type=template&id=821abb56"
import script from "./ba.vue?vue&type=script&lang=js"
export * from "./ba.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__